<template>
    <div class="balcao-view-corpo">

        <MenuTopTemplate :titulo="''"/>

        <button class="btn-fechar-top" type="button" @click="voltar">
            <img src="../assets/icons/close-red-50.png" alt="">
        </button>

        <div v-if="loading && !pedidoEnviado" class="center img-loading-container">
            <img src="../assets/loading.gif" alt="" class="img-loading">
        </div>

        <button @click="navegar">Navegar</button>

        <div v-if="!loading && pedidoEnviado">
            <!-- <BalcaoSucessoView :senha="senhaPedido" :status="statusPedido"/> -->


            <div v-if="this.pix_qr_code && this.pix_qr_code_horario != ''">
                <h2>{{ pix_qr_code }}</h2>

                <MpStatusScreenPix :pix_data="pix_qr_code" :data_hora_qrcode="pix_qr_code_horario"/>
                                   
            </div>
        </div>

        <div v-if="!loading && !pedidoEnviado">
            <TelefoneComDDD @callback="enviarTelefone" :mostrar="true" :loadingEnviarTelefone="this.loadingTelefone" :whiteBackground="false" :numeroTel="telefone"/>

            <h2 style="margin:0px; margin-block: 18px; font-size: 14px;">Dados para retirada no balcão</h2>

            <div v-if="voltouRespostaTelefone">
                <div v-if="clienteExistente">
                    <div class="card">
                        <p>Cliente: {{ dadosClienteApi.nome }}</p>
                        <p>Telefone: {{ telefone }}</p>
                    </div>
                </div>


                <div class="card" style="border: solid 5px red" v-if="this.casaFechada == true">
                    <p>Desculpe! Infelizmente este estabelecimento está fechado no momento para pedidos de balcão.</p>
                </div>

                <div class="card" v-if="this.casaFechada == false">
                    <div class="resumo-pedido">
                        <span>
                            <p>Valor do pedido:</p>
                            <p class="valor-pedido"> {{ valoresEmReais.pedido }}</p>
                        </span>
                        <span>
                            <p>Valor total:</p>
                            <p class="valor-total"> {{ valoresEmReais.total }}</p>
                        </span>
                    </div>
                </div>



                <div>
                    <div v-if="this.iniciarMercadoPago && this.casaFechada == false && pagarPeloApp && this.$store.state.mp_public_key != null">
                        <mp-pagamento
                        :total="this.valorParaMercadoPago"
                        :pedido="this.montarPedidoFinal()"
                        @onSubmit="onSubmitPagamentoMp"
                        @onError="onErrorPagamentoMp"
                        />
                    </div>

                    <div v-if="!this.iniciarMercadoPago && this.casaFechada == false && pagarPeloApp && this.$store.state.mp_public_key != null">
                        <div id="mp-placeholder">
                            <img src="../assets/loading.gif" alt="">
                        </div>
                    </div>
                </div>
            </div>



            <div style="margin-bottom: 100px;"></div>
        </div>
    </div>
</template>

<script>
import MenuTopTemplate from "@/components/Base/MenuTopTemplate.vue";
import ApiDelivery from "../api/ApisDelivery"
import TelefoneComDDD from '@/components/Delivery/TelefoneComDDD.vue';
import Swal from 'sweetalert2';
import BalcaoSucessoView from "./BalcaoSucessoView.vue";
import { converterDinheirStringParaNumber, converterParaDinheiroString } from "@/utils/Dinheiro";
import { setarCores } from '@/utils/SetarCores';
import MpPagamento from '@/components/mercadopago/MpPagamento.vue';
import { gerarIdUnico } from "@/utils/GerarIdUnico";
import MpStatusScreenPix from '@/components/mercadopago/MpStatusScreenPix.vue';
/* eslint-disable */
export default {
    name: "BalcaoView",

    data() {
        return {
            loading: false,
            loadingTelefone: false,
            telefone: "",
            casaFechada: true,
            iniciarMercadoPago: false,
            nomeCliente: "",
            voltouRespostaTelefone: false,
            clienteExistente: false,
            dadosClienteApi: null,
            tipoPagamento: null,
            pedidoEnviado: false,
            habilitarBotaoEnviar: true,
            pagarPeloApp: this.$store.state.mp_public_key != null && (this.$store.state.mp_tem_pix || this.$store.state.mp_tem_cartao),
            pixPaymentObjEnviarComPedido: {},
            aceitaRetirada: this.$store.state.deliveryAceitaRetirada,
            senhaPedido: "",
            statusPedido: "",

            pix_qr_code: null,
            pix_qr_code_horario: "",
            
            resposta_mercado_pago: null,
        };
    },

    created() {
        this.verficiarSeACasaEstaAberta();
        setarCores(this.$store.state.cor1, this.$store.state.cor2, this.$store.state.corTexto)

        setTimeout(() => {
            console.log("COMECEI O MERCADO PAGO")
            this.iniciarMercadoPago = true
        }, 2000);
    },

    watch: {
        pagarPeloApp() {
            console.log("%c mudou aqui", 'background: yellow')
            this.iniciarMercadoPago = false
            setTimeout(() => {
                console.log("COMECEI O MERCADO PAGO")
                this.iniciarMercadoPago = true
            }, 2000);
        }
    },

    computed: {
        cpfCliente(){
            const cpf = this.$store.state.cpfCliente;
            if (cpf) {
                return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
            } else {
                return ""
            }
        },

        pedido() {
            return this.$store.state.deliveryPedido;
        },

        podeEnviarPedido() {
            if (this.casaFechada) {
                return false;
            }
            if (this.tipoPagamento == null) {
                return false;
            }
            return true;
        },

        valoresEmReais() {
            return {
                pedido: converterParaDinheiroString(this.pedido.valorTotalCarrinho),
                total: converterParaDinheiroString(this.valorTotal()),
            }
        },

        valorParaMercadoPago() {
            return converterDinheirStringParaNumber(converterParaDinheiroString(this.valorTotal()))
        },
    },

    methods: {
        verficiarSeACasaEstaAberta() {
            this.loading = true;
            ApiDelivery.verificarCasaEstaAbertaAgora(this.$store.state.cnpj, this.$store.state.numeroEmpresaFK, this.$store.state.idTerminal)
                .then((res) => {
                    console.log(res)
                    this.casaFechada = false;
                })
                .catch((err) => {
                    console.log(err)
                    this.casaFechada = true;
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        valorTotal() {
            return this.$store.state.deliveryPedido.valorTotalCarrinho;
        },

        enviarTelefone(dados) {
            this.telefone = dados.telefone;
            if (this.telefone.length < 12 && this.telefone.length > 9) {
                if (!this.loadingTelefone) {
                    this.loadingTelefone = true;

                    ApiDelivery.buscarCliente(this.$store.state.cnpj, this.telefone)
                    .then(res => {
                        this.loadingTelefone = false;
                        this.voltouRespostaTelefone = true;
                        this.clienteExistente = true;
                        this.dadosClienteApi = res.dadosPessoais;
                        this.$store.dispatch('setCpfCliente', res.dadosPessoais.cpf);
                        this.$store.dispatch('setBalcaoTelefone', this.telefone);
                    })
                    .catch(err => {
                        console.log("erro aqui meu mano");
                        console.log(err);
                        this.loadingTelefone = false;
                        this.voltouRespostaTelefone = true;
                        this.clienteExistente = false;
                        this.$store.dispatch('setBalcaoTelefone', this.telefone);
                    })
                }
            } else {
                Swal.fire({title: "Telefone inválido"})
            }
        },




        async onSubmitPagamentoMp(paymentObject) {
            setTimeout(() => {
                if (this.tipoPagamento == null) {
                    this.tipoPagamento = {}
                }

                this.resposta_mercado_pago = paymentObject.resposta_mercado_pago;

                if (paymentObject.payment_method_id != null) {
                    if (paymentObject.payment_method_id.includes("bank")) {
                        this.tipoPagamento.pagamentoId = "web pix"
                        this.pixPaymentObjEnviarComPedido = paymentObject;
                        this.pix_qr_code = paymentObject.qr_code;
                    }
                    if (paymentObject.payment_method_id.includes("debi")) {
                        this.tipoPagamento.pagamentoId = "web debito"
                    }
                    if (paymentObject.payment_method_id.includes("cred")) {
                        this.tipoPagamento.pagamentoId = "web credito"
                    }
                }
                this.enviarPedido();
            }, 2000);
        },

        async onErrorPagamentoMp() {
            window.location.reload()
        },

        montarPedidoFinal() {
            let pedido = this.$store.state.deliveryPedido
            pedido.tipo = "balcao"

            let pedidoFinal = {
                idUnico: gerarIdUnico(),
                endereco: "retirar",
                pagamento: this.tipoPagamento ?? "web pix",
                pedido: pedido,
                cnpj: this.$store.state.cnpj,
                empresaFK: this.$store.state.numeroEmpresaFK,
                numeroEmpresaFK: this.$store.state.numeroEmpresaFK,
                // cliente: {id: this.dadosClienteApi ? this.dadosClienteApi.id : null, telefone: this.telefone, nome: this.dadosClienteApi ? this.dadosClienteApi.nome : "", cpf: this.$store.state.cpfCliente},
                cliente_telefone: this.telefone,
                taxaEntrega: 0.0,
                isHardRock: this.$store.state.isHardRock,
                dhPrevisaoEntrega: this.getFormattedDateEntrega(),
                valorTotalCarrinho: this.pedido.valorTotalCarrinho,
                created_at: new Date(),
                incluirCpfNaNota: false,
                horarioCompra: this.getFormattedDate(),
                pix_dados: this.pixPaymentObjEnviarComPedido,
                resposta_mercado_pago: this.resposta_mercado_pago
            }
            return pedidoFinal
        },

        getFormattedDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        getFormattedDateEntrega() {
            let prev = Number(this.$store.state.dhPrevisaoEntregaFinal) ?? 0
            const now = new Date();
            now.setMinutes(now.getMinutes() + prev)
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        async enviarPedido() {
            const pagamentoPorPix = this.tipoPagamento.pagamentoId == "web pix";
            console.log(`pagamentoPorPix == ${pagamentoPorPix}`);
            try {
                this.loading = true
                this.habilitarBotaoEnviar = false

                let pedidoFinal = this.montarPedidoFinal()
                console.log("pedidoFinal")
                console.log(pedidoFinal)

                // retorna 
                // {
                //     "message": "Pedido inserido com sucesso",
                //     "dataHoraPedido": "2026-04-28T17:12:14.251559Z",
                //     "id": 2
                // }
                ApiDelivery.enviarPedidoBalcao(pedidoFinal).then(res => {
                    console.log(res)

                    localStorage.setItem("ultimoPedidoBalcao", JSON.stringify({
                        telefone : this.telefone,
                        pix_qr_code: this.pix_qr_code,
                        pix_qr_code_horario: this.pix_qr_code_horario, // esse aqui serve pra mandar pro BalcaoStatusView ja que la vai ter o MpStatusScreenPix que exite esse horario formatado 
                        horario: new Date() // esse aqui serve pra calculos no front pra saber se devemos mostrar o qr code ou não, já que ele tem validade
                    }))
                    
                    this.pix_qr_code_horario =res.dataHoraPedido;
                    this.navegar()

                }).catch(err => {throw err});
                
            } catch (error) {
                Swal.fire({
                    title: "Desculpe-nos!",
                    text: "Ocorreu um erro. Por favor, verifique sua conexão e tente novamente mais tarde."
                });
            }
        },


        navegar(){
            this.$router.push({
                path: "/balcaostatus",
                query: {
                    telefone : this.telefone,
                    pix_qr_code: this.pix_qr_code,
                    pix_qr_code_horario: this.pix_qr_code_horario,
                },
            });
        },



        voltar() {
            this.$router.back();
        },
    },

    components: { MenuTopTemplate, TelefoneComDDD,  BalcaoSucessoView, MpPagamento, MpStatusScreenPix }
}
</script>

<style scoped>
.balcao-view-corpo {
    color: white;
}

p {margin: 2px}
.card {
    font-size: 15px;
    color: black;
    margin-inline: 15px;
    border: white solid 2px;
    padding: 15px;
    border-radius: 5px;
    background: white;
    animation: card-anim 0.5s forwards;
}

@keyframes card-anim {
    from { opacity: 0; transform: translateX(-30%) }
    to { opacity: 1; transform: translateX(0%)}
}

.resumo-pedido span {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
}
.img-loading-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>



